export enum RideType {
  OneWay = "OneWay",
  RoundTrip = "RoundTrip"
}
